import { Col, Row } from 'antd'
import React from 'react'
import ExclamationMarkIco from '../../../components/icons/ExclamationMarkIco'
import {
  CustomLegend,
  CustomLegendLabelRow,
  StyledClearText,
  StyledDynamicText,
  StyledStatusBox,
} from './StyledComponent'

const getCategoryBasedStudent = item => {
  return (
    <span style={{ whiteSpace: 'nowrap' }}>
      <b> {item?.total || item?.count} </b>
      {(Number(item?.male) > 0 ||
        Number(item?.female) > 0 ||
        Number(item?.others) > 0) && <b>{'('}</b>}

      {Number(item?.male) > 0 && (
        <>
          <span style={{ color: '#2BB7DC' }}>{item?.male} (M)</span>
          {Number(item?.female) > 0 && <b>/ </b>}
        </>
      )}
      {Number(item?.female) > 0 && (
        <>
          <span style={{ color: '#DC2B8F' }}>{item?.female} (F) </span>
          {Number(item?.others) > 0 && <b> / </b>}
        </>
      )}
      {Number(item?.others) > 0 && (
        <>
          <span style={{ color: '#8A8A8A' }}>{item?.others} (Oths)</span>
        </>
      )}
      {(Number(item?.male) > 0 ||
        Number(item?.female) > 0 ||
        Number(item?.others) > 0) && <b>{')'}</b>}
    </span>
  )
}

export default function GraphDetails({
  data,
  type,
  statusDetail,
  handleClearClick,
  donutType,
  placement,
}) {
  const filteredStatusData = (statusDetail || []).filter(
    item => !(item.label.trim() === 'Applied' && item.total === '0')
  )

  return (
    <div
      style={{
        position: donutType ? 'absolute' : 'unset',
        bottom: 0,
        width: '100%',
      }}
    >
      <React.Fragment>
        <StyledClearText onClick={handleClearClick} selected={!!data}>
          Clear
        </StyledClearText>
        <StyledStatusBox active={!!data}>
          {!data ? (
            <Row gutter={10} align={'middle'}>
              <Col>
                <ExclamationMarkIco />
              </Col>
              <Col>
                <StyledDynamicText>
                  Note : Click the graph for more details.
                </StyledDynamicText>
              </Col>
            </Row>
          ) : type === 'profileStatus' ? (
            <Row gutter={20} align={'middle'}>
              <Col>
                <StyledDynamicText color="#656565">Selected</StyledDynamicText>
              </Col>
              <Col>
                <StyledDynamicText color="#3249D7" weight={700}>
                  {data?.label}
                </StyledDynamicText>
              </Col>
              <Col>
                <StyledDynamicText weight={700}>
                  No. of Roles Floated : <b>{data?.roleCount}</b>
                </StyledDynamicText>
              </Col>
            </Row>
          ) : (
            <Row gutter={50} align={'middle'}>
              <Col span={type == 'placement' ? 8 : type == 'ctc' ? 8 : 5}>
                <Row gutter={20} align={'middle'}>
                  <Col>
                    <StyledDynamicText color="#656565">
                      Selected
                    </StyledDynamicText>
                    {type == 'ctc' ? (
                      <StyledDynamicText
                        color="#3249D7"
                        weight={700}
                        // width={'75px'}
                      >
                        {data?.label}
                      </StyledDynamicText>
                    ) : null}
                  </Col>
                  {type !== 'ctc' ? (
                    <Col>
                      <StyledDynamicText
                        color="#3249D7"
                        weight={700}
                        width={data?.label?.length > 15 ? '175px' : '75px'}
                      >
                        {data?.label}
                      </StyledDynamicText>
                      {type !== 'placement' ? (
                        <StyledDynamicText weight={700}>
                          Applied : <b>{data?.total_students}</b>
                        </StyledDynamicText>
                      ) : null}
                    </Col>
                  ) : null}
                </Row>
              </Col>
              {type === 'placement' && statusDetail?.length > 0 ? (
                <Col span={16}>
                  <Row gutter={10}>
                    {type === 'placement' &&
                      statusDetail?.map(item => {
                        return (
                          <Col key={item?.label}>
                            <Row align={'middle'}>
                              <CustomLegend
                                color={item?.backgroundColor}
                                borderColor={item?.borderColor}
                              />
                              <CustomLegendLabelRow weight={500}>
                                {item?.label} :{getCategoryBasedStudent(item)}
                              </CustomLegendLabelRow>
                            </Row>
                          </Col>
                        )
                      })}
                  </Row>
                </Col>
              ) : null}
              {type !== 'placement' ? (
                <Col span={type == 'ctc' ? 12 : 5}>
                  {type == 'ctc'
                    ? `Students ${placement ? 'Placed' : 'Selected'}`
                    : 'Company'}{' '}
                  :{' '}
                  {type == 'ctc' ? (
                    getCategoryBasedStudent(data)
                  ) : (
                    <b> {data?.company_name}</b>
                  )}
                </Col>
              ) : null}
              {type !== 'placement' && (
                <Col span={14}>
                  <Row gutter={16}>
                    {[0, 1, 2].map(colIndex => (
                      <Col span={12} key={colIndex}>
                        {filteredStatusData
                          ?.slice(
                            colIndex * Math.ceil(filteredStatusData.length / 2),
                            (colIndex + 1) *
                              Math.ceil(filteredStatusData.length / 2)
                          )
                          .map((item, index) => (
                            <Row
                              align={'middle'}
                              gutter={5}
                              key={index}
                              style={{ marginBottom: '10px' }}
                            >
                              <Col>
                                <CustomLegend color={item?.backgroundColor} />
                              </Col>
                              <Col>
                                <CustomLegendLabelRow weight={500}>
                                  {item?.label} :{getCategoryBasedStudent(item)}
                                </CustomLegendLabelRow>
                              </Col>
                            </Row>
                          ))}
                      </Col>
                    ))}
                  </Row>
                </Col>
              )}
            </Row>
          )}
        </StyledStatusBox>
      </React.Fragment>
    </div>
  )
}
